export const budgetBenchmarks = {
  "2.1": { unit: "per sqm", low: 500,  mid: 2000, high: 4000, label: "Construction" },
  "2.2": { unit: "per room", low: 5000, mid: 12500, high: 40000, label: "FF&E + OS&E" },
  "6.1": { unit: "% of total", low: 5,  mid: 10,   high: 15,   label: "Contingency" }
};